import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Fill, ToolbarButton } from '@wordpress/components';
import { displayShortcut } from '@wordpress/keycodes';
export function RichTextToolbarButton(_ref) {
  let {
    name,
    shortcutType,
    shortcutCharacter,
    ...props
  } = _ref;
  let shortcut;
  let fillName = 'RichText.ToolbarControls';

  if (name) {
    fillName += `.${name}`;
  }

  if (shortcutType && shortcutCharacter) {
    shortcut = displayShortcut[shortcutType](shortcutCharacter);
  }

  return createElement(Fill, {
    name: fillName
  }, createElement(ToolbarButton, _extends({}, props, {
    shortcut: shortcut
  })));
}
//# sourceMappingURL=toolbar-button.js.map